import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ClientRestrictionsTab } from 'views/portfolio/PortfolioPage/tabs/equity-preferences/client-restrictions/ClientRestrictionsTab';
import { SRIRestrictionsTab } from 'views/portfolio/PortfolioPage/tabs/equity-preferences/sri-restrictions/SRIRestrictionsTab';

import { InvestmentStylesTab } from './investment-styles/InvestmentStylesTab';

export const EquityPreferencesTab = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Define sub-tabs for restrictions
    const subTabs = [
        { value: 'client', label: 'Client Restrictions' },
        { value: 'sri', label: 'SRI Restrictions' },
        { value: 'investment-styles', label: 'Investment Styles' },
    ];

    // Get current sub-tab from URL path
    const getCurrentSubTab = () => {
        const pathSegments = location.pathname.split('/');
        const lastSegment = pathSegments[pathSegments.length - 1];

        // If we're on the restrictions base path, default to client
        if (lastSegment === 'restrictions') {
            return 'client';
        }

        // Check if the last segment matches a sub-tab
        const currentSubTab = subTabs.find((tab) => tab.value === lastSegment);
        return currentSubTab ? currentSubTab.value : 'client';
    };

    // Handle sub-tab change and navigate to the corresponding route
    const handleSubTabChange = (value: string) => {
        const basePath = location.pathname.replace(/\/(client|sri|investment-styles)$/, '');
        navigate(`${basePath}/${value}`);
    };

    return (
        <div>
            <h2 className="text-cocoa-1000 text-xl">Equity Preferences</h2>

            <Tabs value={getCurrentSubTab()} onValueChange={handleSubTabChange}>
                <TabsList className="flex border-none border-gray-300">
                    <TabsTrigger value="client">Client Restrictions</TabsTrigger>
                    <TabsTrigger value="sri">SRI Restrictions</TabsTrigger>
                    <TabsTrigger value="investment-styles">Investment Styles</TabsTrigger>
                </TabsList>

                <TabsContent value="client" className="mt-6">
                    <ClientRestrictionsTab />
                </TabsContent>

                <TabsContent value="sri" className="mt-6">
                    <SRIRestrictionsTab />
                </TabsContent>

                <TabsContent value="investment-styles" className="mt-6">
                    <InvestmentStylesTab />
                </TabsContent>
            </Tabs>
        </div>
    );
};
